export default "__VITE_ASSET__Bm6yGRSc__"